<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { formatedDate } from "../../../utils/proposalValidation";

export default {
    name: "CPTemp16",
    components: {
        SpellCheckedText,
        PhotoBox
    },
    props: {
        projects: { type: Object, required: true },
        pageGap: { type: Boolean, default: true },
        startPage: { type: Number, default: 1 },
    },
    computed: {
        projectPages() {
            return this.projects.projects || [];
        }
    },
    methods: {
        formatedDate
    }
};
</script>

<template>
    <div class="main-container" :style="{
        gap: pageGap ? '20px' : '0px',
        '--header-color': projects.style.colorScheme.header,
        '--body-color': projects.style.colorScheme.body,
        '--footer-color': projects.style.colorScheme.footer,
        '--heading-color': projects.style.heading.color,
        '--heading-size': projects.style.heading.size + 'px',
        '--heading-font': projects.style.heading.font,
        '--heading-weight': projects.style.heading.bold ? 'bold' : 'normal',
        '--heading-style': projects.style.heading.italic ? 'italic' : 'normal',
        '--heading-decoration': projects.style.heading.underline ? 'underline' : 'none',
        '--label-color': projects.style.label.color,
        '--label-size': projects.style.label.size + 'px',
        '--label-font': projects.style.label.font,
        '--label-weight': projects.style.label.bold ? 'bold' : 'normal',
        '--label-style': projects.style.label.italic ? 'italic' : 'normal',
        '--label-decoration': projects.style.label.underline ? 'underline' : 'none',
        '--text-color': projects.style.text.color,
        '--text-size': projects.style.text.size + 'px',
        '--text-font': projects.style.text.font,
        '--text-weight': projects.style.text.bold ? 'bold' : 'normal',
        '--text-style': projects.style.text.italic ? 'italic' : 'normal',
        '--text-decoration': projects.style.text.underline ? 'underline' : 'none',
    }">
        <div v-for="(project, index) in projectPages" :key="index" class="sub-container page-unit">
            <div class="split-layout">
                <!-- LEFT CONTENT COLUMN -->
                <div class="left-col">
                    <div class="section-header">
                        <SpellCheckedText :value="projects.title || 'Comparable Projects'"
                            @input="projects.title = $event" />
                    </div>

                    <div class="banner">
                        <h1 class="project-title">
                            <SpellCheckedText :value="project.projectName || 'Project Name'"
                                @input="project.projectName = $event" />
                        </h1>
                        <p class="project-loc">
                            <SpellCheckedText
                                :value="(project.city ? project.city + ', ' : '') + (project.stateProvince || '')"
                                @input="(val) => { /* Custom parser if needed */ }" />
                        </p>
                    </div>

                    <div class="left-content-split">
                        <!-- Sub column 1 (Left) -->
                        <div class="sub-col-1">
                            <div class="block-section description-block">
                                <h3 class="label-heading">PROJECT DESCRIPTION</h3>
                                <div class="text-content mt-1">
                                    <SpellCheckedText :value="project.projectDetails || ''"
                                        @input="project.projectDetails = $event" />
                                </div>
                            </div>

                            <div class="bottom-section" v-if="project.projectTeam && project.projectTeam.length > 0">
                                <!-- <div class="info-box">
                                    <SpellCheckedText
                                        :value="project.extraInfo || 'Box for additional text information or photo'"
                                        @input="project.extraInfo = $event" />
                                </div> -->
                                <div class="block-section">
                                    <h3 class="label-heading">Project Team Members</h3>
                                    <div class="line-under-green" />
                                    <div class="team-list">
                                        <div v-for="(member, mIdx) in project.projectTeam" :key="mIdx"
                                            class="team-member">
                                            <div class="member-avatar photobox">
                                                <PhotoBox class="photobox" :project="member"
                                                    :bgColor="projects.style.colorScheme.body" type="profile" />
                                            </div>
                                            <div class="member-text">
                                                <span>
                                                    <SpellCheckedText :value="member.name"
                                                        @input="member.name = $event" />
                                                </span>
                                                <span v-if="member.role" class="member-role"> -
                                                    <SpellCheckedText :value="member.role"
                                                        @input="member.role = $event" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Sub column 2 (Right) -->
                        <div class="sub-col-2">
                            <div class="block-section">
                                <h3 class="label-heading">PROJECT DETAILS</h3>
                                <div class="details-list">
                                    <div class="detail-row">
                                        <span class="detail-label">Original Value: </span>
                                        <span class="detail-value text-content">
                                            {{ project.OriginalValue ? `$${project.OriginalValue.toLocaleString()}` :
                                                'N/A' }}
                                        </span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Final Cost: </span>
                                        <span class="detail-value text-content">
                                            {{ project.value ? `$${project.value.toLocaleString()}` : 'N/A' }}
                                        </span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Current Phase: </span>
                                        <span class="detail-value text-content">
                                            <SpellCheckedText :value="(project.projectStatus && project.projectStatus.statusName) || 'N/A'"
                                                @input="project.projectStatus.statusName = $event" />
                                        </span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Completion Date: </span>
                                        <span class="detail-value text-content">
                                            <SpellCheckedText
                                                :value="formatedDate(project.constructionCompletionDate) || 'N/A'"
                                                @input="project.constructionCompletionDate = $event" />
                                        </span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Delivery Method: </span>
                                        <span class="detail-value text-content">
                                            <SpellCheckedText :value="(project.contractType && project.contractType.contractTypeName) || 'N/A'"
                                                @input="project.contractType.contractTypeName = $event" />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div v-if="project.keyFeatures && project.keyFeatures.length > 0" class="block-section">
                                <h3 class="label-heading">RELEVANT FEATURES</h3>
                                <ul class="features-list">
                                    <li v-for="(feature, fIdx) in project.keyFeatures" :key="fIdx"
                                        class="features-content">
                                        {{ feature }}
                                    </li>
                                </ul>
                            </div>

                            <div class="reference-section block-section">
                                <h3 class="label-heading-dark">Owner Reference</h3>
                                <div class="line-under-green" />
                                <div class="ref-content text-content mb-2">
                                    <SpellCheckedText :value="project.clientAccountName || ''"
                                        @input="project.clientAccountName = $event" />
                                    <SpellCheckedText
                                        :value="project.primaryClientAccountContact.externalContactName || ''"
                                        @input="project.primaryClientAccountContact.externalContactName = $event" />
                                    <SpellCheckedText
                                        :value="project.primaryClientAccountContact.externalContactDetails || ''"
                                        @input="project.primaryClientAccountContact.externalContactDetails = $event" />
                                    <SpellCheckedText :value="project.primaryClientAccountContact.phoneNo || ''"
                                        @input="project.primaryClientAccountContact.phoneNo = $event" />
                                    <SpellCheckedText :value="project.primaryClientAccountContact.email || ''"
                                        @input="project.primaryClientAccountContact.email = $event" />
                                </div>

                                <h3 class="label-heading-dark">Architect Reference</h3>
                                <div class="line-under-green" />
                                <div class="ref-content text-content">

                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <!-- RIGHT IMAGE COLUMN -->
                <div class="right-col">
                    <div class="img-stack">
                        <div class="stacked-image img1  photobox">
                            <PhotoBox :project="project" :index="0" :bgColor="projects.style.colorScheme.body" />
                        </div>
                        <div class="stacked-image img2 photobox">
                            <PhotoBox :project="project" :index="1" :bgColor="projects.style.colorScheme.body" />
                        </div>
                        <div class="stacked-image img3 photobox">
                            <PhotoBox :project="project" :index="2" :bgColor="projects.style.colorScheme.body" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer-section">
                <div class="footer-left">
                    <SpellCheckedText :value="projects.opprName || 'BCIT Academic Center Project'"
                        @input="projects.opprName = $event" />
                </div>
                <div class="footer-right">
                    <SpellCheckedText :value="projects.submittedBy || ''" @input="projects.submittedBy = $event" />
                    <span class="divider">|</span>
                    <span class="page-num">{{ startPage + index
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main-container {
    display: flex;
    flex-direction: column;
    width: 297mm;
    min-height: 210mm;
    position: relative;
    box-sizing: border-box;

    &:hover {
        .photobox :deep(.photo-overlay) {
            opacity: 1;
        }

        .photobox :deep(img) {
            opacity: 0.9;
        }
    }

    .sub-container {
        display: flex;
        flex-direction: column;
        background: white;
        width: 297mm;
        height: 210mm;
        position: relative;
        overflow: hidden;
    }

    .split-layout {
        display: flex;
        gap: 40px;
        width: 100%;
        height: 749.22px;
        overflow: hidden;
    }

    .left-col {
        width: 60%;
        position: relative;
        display: flex;
        flex-direction: column;
        background: white;
        z-index: 2;
        height: 100%;

        .section-header {
            color: black;
            font-size: 16px;
            font-weight: bold;
            font-family: Helvetica;
            margin: 15px 15px 5px 15px;
            letter-spacing: 0.5px;
        }

        .banner {
            background: var(--header-color);
            border-radius: 0 10px 10px 0;
            padding: 20px 40px;
            margin-bottom: 20px;

            .project-title {
                color: white;
                font-size: 20px;
                font-weight: bold;
                font-family: Helvetica;
                margin: 0 0 5px 0;
            }

            .project-loc {
                color: white;
                font-size: 14px;
                margin: 0;
                font-family: Helvetica;
            }
        }

        .left-content-split {
            display: flex;
            gap: 30px;
            padding: 0 0 0 40px;
            flex: 1;
            min-height: 0;
        }

        .sub-col-1 {
            flex: 1.1;
            display: flex;
            flex-direction: column;
            gap: 10px;
            min-height: 0;
        }

        .sub-col-2 {
            flex: 0.9;
            display: flex;
            flex-direction: column;
            gap: 20px;
            min-height: 0;
        }

        .block-section {
            display: flex;
            flex-direction: column;
            overflow: hidden;
            gap: 4px;

            &.description-block {
                flex: 1;
                min-height: 0;
            }
        }

        .label-heading {
            color: var(--heading-color);
            font-size: var(--heading-size);
            font-weight: var(--heading-weight);
            font-family: var(--heading-font);
            font-style: var(--heading-style);
            text-decoration: var(--heading-decoration);
            margin: 0;
			text-align:left;
        }

        .label-heading-dark {
            color: var(--label-color);
            font-size: var(--label-size);
            font-weight: var(--label-weight);
            font-family: var(--label-font);
            font-style: var(--label-style);
            text-decoration: var(--label-decoration);
            padding-right: 20px;
            margin: 0;
        }

        .line-under-green {
            border-bottom: 3px solid var(--header-color);
            margin-bottom: 5px;
            width: 80%;
        }

        .text-content {
            color: var(--text-color);
            font-size: var(--text-size);
            font-weight: var(--text-weight);
            font-family: var(--text-font);
            font-style: var(--text-style);
            text-decoration: var(--text-decoration);
            line-height: 1.2;
            overflow: hidden;
            white-space: pre-wrap;
        }

        .bottom-section {
            display: flex;
            flex-direction: column;
            margin-top: auto;
            gap: 10px;
            flex-shrink: 0;

            .info-box {
                border: 1px solid black;
                padding: 10px;
                border-radius: 4px;
                min-height: 70px;
                color: var(--text-color);
                font-size: var(--text-size);
                font-weight: var(--text-weight);
                font-family: var(--text-font);
                font-style: var(--text-style);
                text-decoration: var(--text-decoration);
            }

            .team-list {
                display: flex;
                flex-direction: column;
                gap: 5px;
                height: auto;
                max-height: 250px;
                overflow: hidden;

                .team-member {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .member-avatar {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        overflow: hidden;
                        background: #eee;
                        flex-shrink: 0;

                        &:hover {
                            .photobox :deep(.photo-overlay) {
                                gap: 0px;
                            }

                            .photobox :deep(.overlay-btn) {
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }

                    .member-text {
                        font-size: var(--text-size);
                        color: var(--text-color);
                        font-family: var(--text-font);
                        font-weight: var(--text-weight);
                        font-style: var(--text-style);
                        text-decoration: var(--text-decoration);
                        margin: 0;
                    }
                }
            }
        }

        .details-list {
            display: flex;
            flex-direction: column;
            margin-left: 5px;

            .detail-row {
                display: flex;
                padding: 4px 0;
                border-bottom: 3px solid var(--header-color);
                font-size: 10.5px;
                font-family: Helvetica;
                align-items: baseline;

                .detail-label {
                    color: var(--label-color);
                    font-size: var(--label-size);
                    font-weight: var(--label-weight);
                    font-family: var(--label-font);
                    font-style: var(--label-style);
                    text-decoration: var(--label-decoration);
                    margin-right: 5px;
                    flex-shrink: 0;
                }

                .detail-value {
                    color: var(--text-color);
                    font-size: var(--text-size);
                    font-weight: var(--text-weight);
                    font-family: var(--text-font);
                    font-style: var(--text-style);
                    text-decoration: var(--text-decoration);
                    margin: 0;
                }
            }
        }

        .features-list {
            display: flex;
            flex-direction: column;
            padding-left: 5px;
            list-style-position: inside;
            gap: 3px;
            margin: 0;

            .features-content {
                flex: 1;
                color: var(--label-color);
                font-size: var(--label-size);
                font-weight: var(--label-weight);
                font-family: var(--label-font);
                font-style: var(--label-style);
                text-decoration: var(--label-decoration);
                line-height: 1.4;
                max-height: 250px;
                overflow: hidden;
            }
        }

        .reference-section {
            margin: 5px 0px 0px 5px;

            .ref-content {
                display: flex;
                flex-direction: column;
                gap: 5px;
                line-height: 1.3;

                p {
                    margin: 0;
                }
            }
        }
    }

    .right-col {
        width: 40%;
        position: relative;
        display: flex;
        flex-direction: column;

        .img-stack {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            gap: 5px;
            padding: 0;

            .stacked-image {
                width: 100%;
                position: relative;
                overflow: hidden;
            }

            .img1 {
                flex: 1.2;
            }

            .img2 {
                flex: 1;
            }

            .img3 {
                flex: 1.2;
            }
        }
    }

    .footer-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 40px;
        font-size: 12px;
        color: var(--footer-color);
        font-weight: bold;

        .footer-right {
            display: flex;
            align-items: center;

            .divider {
                margin: 0 10px;
            }

            .page-num {
                color: var(--heading-color);
                font-size: 16px;
            }
        }
    }
}
</style>
